import React from "react"

import { HeaderCell } from "../../styles/TableCell.styled"

import HeaderPackage from "./Package"

const PackageTableHeaderCell = ({
  title,
  subtitle,
  color,
  stars,
  cta,
  scope,
  width,
}) => {
  return (
    <HeaderCell scope={scope} width={width}>
      <HeaderPackage
        title={title}
        subtitle={subtitle}
        color={color}
        stars={stars}
        cta={cta}
      />
    </HeaderCell>
  )
}

export default PackageTableHeaderCell
